import React from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { WhatWeDoSection } from '../components/WhatWeDoSection';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-[#0f2424] text-white selection:bg-[#4fd1c5] selection:text-[#0f2424]" data-id="element-284">
      <Navigation data-id="element-285" />
      <main data-id="element-286">
        <Hero data-id="element-287" />
        <WhatWeDoSection data-id="element-288" />
      </main>
      <Footer data-id="element-289" />
    </div>;
}